import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/index.scss'
import './assets/styles/element-variables.scss'
// 导入权限指令
import permission, { role } from './directives/permission'
// 进度条
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify)

// 工具
import brandUtils from "./utils/brandUtils.js"
Vue.prototype.$brandUtils = brandUtils;

import Util from '@/utils/util.js'
Vue.prototype.$util = Util

// 注册全局指令
Vue.directive('permission', permission)
Vue.directive('role', role)

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
